import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/mediconsult.css";
import "./index.css";
import App from "./App";
import "./styles/massage-cards.css";
import authReducer from "./state";
import { configureStore } from "@reduxjs/toolkit";
import { Provider } from "react-redux";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";

const persistedRememberLogin = (value) => {
  try {
    const parsed = JSON.parse(value || "{}");
    const remember = parsed.rememberLogin;
    return typeof remember === "string" ? JSON.parse(remember) === true : remember === true;
  } catch {
    return false;
  }
};

const authStorage = {
  getItem: (key) => {
    try {
      return Promise.resolve(
        window.localStorage.getItem(key) || window.sessionStorage.getItem(key)
      );
    } catch {
      return Promise.resolve(null);
    }
  },
  setItem: (key, value) => {
    try {
      if (persistedRememberLogin(value)) {
        window.localStorage.setItem(key, value);
        window.sessionStorage.removeItem(key);
      } else {
        window.sessionStorage.setItem(key, value);
        window.localStorage.removeItem(key);
      }
    } catch {
      /* Ignore unavailable browser storage. */
    }
    return Promise.resolve();
  },
  removeItem: (key) => {
    try {
      window.localStorage.removeItem(key);
      window.sessionStorage.removeItem(key);
    } catch {
      /* Ignore unavailable browser storage. */
    }
    return Promise.resolve();
  },
};

const persistConfig = { key: "dr-hoffmann", storage: authStorage, version: 2 };
const persistedReducer = persistReducer(persistConfig, authReducer);
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistStore(store)}>
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>
);
